module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjBAMAAADs965qAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAr0lEQVQoz63RMQrCQBBA0W8iWChYW2ljnyOksFdbq4AHiN2UegYv4BE8wBY5QmysA14gjSAqZCwUNrtbKf7yDQwDA0QzWwJAr1Jbswc6pbZrEuir2wVyj+5w9EjBLn8uYayaYscZMHToRkCnkHawMoVDGyJVdWhB16f0N+LdPKQ8pG1Ih5Da1xuTEBtT/+PU76kKqfCp9e0PPWDg0RXi2qUMGDl0BmAqIiIyIRJZAy/PKsDXTGT/OQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/facebook-hover.png
// module id = 258
// module chunks = 0